function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import clone from "clone";
import { get as _get } from "../../utils/get";
import { Logger } from "../../utils/Logger";
import { set } from "../../utils/set";
var allFieldsSymbol = Symbol("all");
var anyFieldSymbol = Symbol("any");
var lengthSymbol = Symbol("length");
var logger = new Logger("ContainerContext");
function isPromisedData(input) {
  return typeof input === "function";
}
export var ContainerContext = /*#__PURE__*/function () {
  function ContainerContext(initData) {
    var _this = this;
    _classCallCheck(this, ContainerContext);
    this.subscriberFlushQueue = [];
    this.validatorResults = _defineProperty({}, lengthSymbol, 0);
    this.options = {
      disabled: true,
      compact: false
    };
    this.subscribers = _defineProperty(_defineProperty({}, allFieldsSymbol, []), anyFieldSymbol, []);
    this.loaded = new Promise(function (resolve) {
      if (isPromisedData(initData)) {
        initData().then(function (data) {
          _this.update(data);
          _this.updateOptions({
            disabled: false
          });
          resolve();
        });
      } else {
        // Do not rely on direct data returned by data provider
        // otherwise the owner of the object can modify internal data of context
        _this.data = clone(initData);
        _this.options = {
          disabled: false,
          compact: false
        };
        resolve();
      }
    });
  }
  return _createClass(ContainerContext, [{
    key: "onLoad",
    value: function onLoad(callback) {
      this.loaded.then(function () {
        return callback();
      });
    }
  }, {
    key: "setSubscriber",
    value: function setSubscriber(key, callback) {
      var subscribers = this.subscribers[key] || [];
      subscribers.push(callback);
      this.subscribers[key] = subscribers;
    }
  }, {
    key: "getSubscriber",
    value: function getSubscriber(key) {
      return this.subscribers[key] || [];
    }
  }, {
    key: "removeSubscriber",
    value: function removeSubscriber(key, callback) {
      var index = this.subscribers[key].findIndex(function (fn) {
        return fn === callback;
      });
      if (index > -1) {
        this.subscribers[key] = this.subscribers[key].filter(function (cb) {
          return cb !== callback;
        });
      }
    }
  }, {
    key: "removeSubscribers",
    value: function removeSubscribers(deps, callback) {
      this.removeSubscriber(allFieldsSymbol, callback);
      if (deps.length === 0) {
        this.removeSubscriber(anyFieldSymbol, callback);
      } else {
        var _iterator = _createForOfIteratorHelper(deps),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var dependency = _step.value;
            this.removeSubscriber(this.getKeyForPath(dependency), callback);
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
    }
  }, {
    key: "getKeyForPath",
    value: function getKeyForPath(fieldPath) {
      return fieldPath.join(">");
    }
  }, {
    key: "update",
    value: function update(updateData) {
      var _this2 = this;
      if (isPromisedData(updateData)) {
        updateData().then(function (data) {
          return _this2.update(data);
        });
      } else {
        // Do not rely on direct data returned by data provider
        // otherwise the owner of the object can modify internal data of context
        this.data = clone(updateData);
        this.notify([allFieldsSymbol], [""], this.data);
      }
    }
  }, {
    key: "notify",
    value: function notify(selectors, fieldPath, value) {
      var _this3 = this;
      var _a;
      var subscribers = selectors.reduce(function (acc, selector) {
        return [].concat(_toConsumableArray(acc), _toConsumableArray(_this3.getSubscriber(selector)));
      }, []);
      // The same callback can be located in different subscriptions. `Set` will deduplicate it
      // Queue is needed to guarantee the correct order events!!
      // Subscriber can internally call notify as well
      //
      // Notify level 1 index 0:
      //      setData()
      //      notify(newData)
      //          Notify Level 2 index 0:
      //               unsubscribe old consumer, register new one
      // Notify level 1 index 1:
      //      call consumer that got registered when Notify level 2 index 0 executed
      //
      // With queue the order is correct
      //
      // Notify level 1 index 0:
      //  setData();
      //  notify(newData) (queued)
      // Notify level 1 index 1
      //  call old consumer
      // Notify level 2 index 0:
      // ...
      new Set(subscribers).forEach(function (subscriber) {
        return _this3.subscriberFlushQueue.push(function () {
          return subscriber(fieldPath, value, _this3.data);
        });
      });
      while (this.subscriberFlushQueue.length > 0) {
        (_a = this.subscriberFlushQueue.shift()) === null || _a === void 0 ? void 0 : _a();
      }
    }
  }, {
    key: "updateField",
    value: function updateField(path, value) {
      if (!this.data && path.length > 0) {
        logger.warn("Trying to update empty data or empty path", {
          currentData: this.data,
          path: path
        });
        return;
      }
      set(this.data, path, value);
      var subscribeKey = this.getKeyForPath(path);
      this.notify([subscribeKey, allFieldsSymbol], path, value);
    }
  }, {
    key: "updateOptions",
    value: function updateOptions(options) {
      var shouldNotify = false;
      if (options.disabled !== undefined && this.options.disabled !== options.disabled) {
        this.options.disabled = options.disabled;
        shouldNotify = true;
      }
      if (options.compact !== undefined && this.options.compact !== options.compact) {
        this.options.compact = options.compact;
        shouldNotify = true;
      }
      if (shouldNotify) {
        this.notify([allFieldsSymbol], [""], this.data);
      }
    }
  }, {
    key: "updateValidationResults",
    value: function updateValidationResults(results) {
      var _this4 = this;
      if (results.length === 0 && this.validatorResults[lengthSymbol] === 0) {
        return;
      }
      var prevKeys = Object.keys(this.validatorResults);
      this.validatorResults = results.reduce(function (acc, result) {
        var _iterator2 = _createForOfIteratorHelper(_this4.mapValidationResult([], result)),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var validationError = _step2.value;
            var key = _this4.getKeyForPath(validationError.path);
            acc[key] = acc[key] || [];
            acc[key].push(validationError.validatorResult);
            acc[lengthSymbol] += 1;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
        return acc;
      }, _defineProperty({}, lengthSymbol, 0));
      var fieldsToNotify = new Set([].concat(prevKeys, _toConsumableArray(Object.keys(this.validatorResults))));
      this.notify(Array.from(fieldsToNotify), [""], this.data);
    }
  }, {
    key: "mapValidationResult",
    value: function mapValidationResult(path, result) {
      var _this5 = this;
      if (result.property === undefined) {
        return [];
      }
      var propertyPaths = (typeof result.property === "string" ? result.property.split(",").map(function (p) {
        return p.trim();
      }) : [String(result.property)]).map(function (leaf) {
        return [].concat(_toConsumableArray(path), [leaf]);
      });
      return propertyPaths.flatMap(function (propertyPath) {
        var _a;
        return [{
          validatorResult: result,
          path: propertyPath
        }].concat(_toConsumableArray(((_a = result.children) !== null && _a !== void 0 ? _a : []).reduce(function (acc, child) {
          return [].concat(_toConsumableArray(acc), _toConsumableArray(_this5.mapValidationResult(propertyPath, child)));
        }, [])));
      });
    }
  }, {
    key: "get",
    value: function get(path) {
      if (!this.data) {
        return undefined;
      }
      return _get(this.data, path);
    }
  }, {
    key: "getData",
    value: function getData() {
      return this.data;
    }
  }, {
    key: "getDataClone",
    value: function getDataClone() {
      return clone(this.data);
    }
  }, {
    key: "getOptions",
    value: function getOptions() {
      return this.options;
    }
  }, {
    key: "getValidationResult",
    value: function getValidationResult(path) {
      var _a;
      return (_a = this.validatorResults[this.getKeyForPath(path)]) !== null && _a !== void 0 ? _a : null;
    }
    // NOTE: If you use dependencies please don't forget to add you field to the list as well
  }, {
    key: "subscribe",
    value: function subscribe(callback) {
      var _this6 = this;
      var deps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      this.setSubscriber(allFieldsSymbol, callback);
      if (deps.length === 0) {
        this.setSubscriber(anyFieldSymbol, callback);
      } else {
        var _iterator3 = _createForOfIteratorHelper(deps),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var dependency = _step3.value;
            this.setSubscriber(this.getKeyForPath(dependency), callback);
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return function () {
        return _this6.removeSubscribers(deps, callback);
      };
    }
  }]);
}();